<template>
  <div>
    <div class="text-center">
      <h1 class="pt-4 pb-1">{{ $store.state.logged.data.nome_usuario }}</h1>
      <div class="grey--text mb-6">
        <div>
          LOGIN: {{ $store.state.logged.data.login }}
          <span v-show="id_agent">&nbsp;&nbsp;&nbsp; ID: {{ id_agent }}</span>
        </div>
      </div>
      <h3 v-show="count">{{ $t("qtdSales") }}: {{ count }}</h3>
    </div>
    <Resume
      :data_resume="{
        data: items,
        keys: ['sales', 'commission', 'prizes_paid'],
        showSum: true,
      }"
    />
  </div>
</template>
<script>
import Resume from "@/components/backoffice/resume_global/resume";
export default {
  name: "AgentFinancialExtractSimplified",
  components: {
    Resume,
  },
  data: () => ({
    items: [],
    id_agent: "",
    count: 0,
  }),
  computed: {
    // Global Filters
    rangeGlobalDate() {
      return this.$store.state.rangeGlobal.date;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  mounted() {
    this.salesReport();
  },
  watch: {
    saveFilters(val) {
      val && this.salesReport();
    },
  },
  methods: {
    salesReport() {
      var body = {
        ...this.rangeGlobalDate,
      };

      this.$request
        .post("/agent/retail/financial/salesReport", body)
        .then((response) => {
          this.count = response.data.dados.count;
          this.id_agent = response.data.dados.id_agent;
          var data = [response.data.dados];
          this.items = data.map((element) => {
            element.commission = Number(element.commission) * -1;
            element.prizes_paid = Number(element.prizes_paid) * -1;
            return element;
          });
        })
        .catch(() => {
          this.items = [];
          this.id_agent = "";
        });
    },
  },
};
</script>
